import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { VerifyOtpResponse } from '@/api/auth/types';

interface AuthState {
  user: VerifyOtpResponse | null;
  token: string | null;
}

function readStoredUser(): VerifyOtpResponse | null {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) return null;
    const u = JSON.parse(raw) as VerifyOtpResponse;
    return u?.id ? u : null;
  } catch {
    return null;
  }
}

function readStoredToken(): string | null {
  const raw = localStorage.getItem('accessToken');
  // Guard against the string literal "undefined" / "null" written by a past bug
  if (!raw || raw === 'undefined' || raw === 'null') return null;
  return raw;
}

const storedUser = readStoredUser();

const initialState: AuthState = {
  user: storedUser,
  // Prefer localStorage token; fall back to the token embedded in the stored user object
  token: readStoredToken() ?? storedUser?.token ?? null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<VerifyOtpResponse>) => {
      state.user = action.payload;
      state.token = action.payload.token;
    },
    clearUser: state => {
      state.user = null;
      state.token = null;
    },
  },
});

export const { setUser, clearUser } = authSlice.actions;
export default authSlice.reducer;
